<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div class="mobile-note-original">
        <el-button class="originalBtn"
                   v-clipboard:copy="detailData"
                   v-clipboard:success="onCopy"
                   v-clipboard:error="onError"
                   type="primary" size="small">复制
        </el-button>
        <pre v-html="detailData"></pre>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'

    Vue.use(VueClipboard)
    export default {
        name: "mobile-noteoriginal",
        props: {
            detailData: String,
            isApp: Boolean
        },
        data() {
            return {}
        },

        methods: {
            onCopy: function (e) {
                this.$message({
                    message: '复制成功',
                    type: 'success'
                });
            },
            onError: function (e) {
                this.$message.error('复制失败，请手动复制');
            }
        }
    }
</script>

<style lang="scss">
    .originalBtn {
        float: right;
        background: gray !important;
    }

</style>
